// client.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { name } from '@azure/msal-angular/packageMetadata';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ClientService {
    // private apiUrl = '/admin/v1';
    private apiUrl;

    constructor(private http: HttpClient) {
        this.apiUrl = environment.gyanApiUrl + 'admin/v1';
    }

    // Create a new client
    createClient(clientData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/add-client`, clientData);
    }
    getVerifyisClientExist(clientName: any): Observable<any> {
        return this.http.get(`${this.apiUrl}/verifyisclientexist?clientName=` + encodeURIComponent(clientName));
    }

    // Get all clients
    getClients(clientList: any): Observable<any> {
        return this.http.post<any>(`${this.apiUrl}/client-list`, clientList);
    }
    updateClient(clientData: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/update-client`, clientData);
    }
}
